export enum AlertTypes {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  ThemeBackground = 'theme-background'
}
